export default "__VITE_ASSET__CmB$LKOf__"